const desc = `<p>נחמה פוחצ'בסקי <span class="bold">דבר </span> [1934 06 26]</p>`;

export default desc;
